import React from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"

import {colors} from "../../utils/styles"
import {clearError} from "../../state/app/actions"
import {navigateHome} from "../../utils/routing"
import {N2C3Modal} from "./N2C3Modal"

const imageStyle = {
  marginRight: 10,
  verticalAlign: 'middle'
}

const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'row'
}

const buttonStyle = {
  backgroundColor: colors.blue,
  height: 24,
  width: 87,
  color: colors.white,
  border: 'none'
}

const contentStyle = {
  padding: 20,
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center'
}

export class ErrorModal extends React.Component {
  clearError() {
    this.props.actions.clearError()
    navigateHome()
  }

  render() {
    return (this.props.hasError) ? (
            <N2C3Modal width={407} modalClass={"error-modal"}
                       extraStyle={{fontWeight: 600, color: colors.red, height: 96}}>
              <div style={contentStyle}>
                <div>
                  <img src="images/alert-red.svg" style={imageStyle}/>
                  <span>Application error encountered and has been reported.</span>
                </div>
                <div style={buttonContainerStyle}>
                  <button style={buttonStyle} onClick={this.clearError.bind(this)}>OK</button>
                </div>
              </div>
            </N2C3Modal>
        )
        : null
  }
}

function mapStateToProps(state) {
  return {
    hasError: state.app.hasError
  }
}

function mapDispatchToProps(dispatch) {
  return {actions: bindActionCreators({clearError}, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal)